angular.module('property-deal')
    .controller('PropertyDealShowController', function ($scope, $rootScope, $window, $filter, $state, item, PropertyDeal, LeadService, PropertyService, PropertyDealService, Principal) {
        this.LeadService = LeadService
        this.PropertyService = PropertyService
        this.PropertyDealService = PropertyDealService

        this.cancel = () => {
            if ($window.history.length > 2)
                $window.history.back();
            else {
                $state.go('propertyDealList');
            }
        }

        this.$onInit = () => {
            this.id = item.id
            PropertyDeal.get({id: this.id}).$promise.then(item => this.item = item, () => this.cancel())
            this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD'])
            this.canChangePrice = Principal.hasAnyAuthority(["ROLE_PROPERTY_DEAL_PRICE_CHANGE", "ROLE_PROPERTY_DEAL_PRICE_CHANGE_NO_LIMIT"])
        }

        this.changePrice = (item) => {
            return PropertyDealService.changePrice(angular.copy(item)).then(result => {
                let form = {
                    id: this.id,
                    itemId: item.id,
                    calculationMethod: result.calculationMethod,
                    calculationBasedOn: result.calculationBasedOn,
                    vat: result.vat,
                    pricingBase: result.pricingBase,
                    pricing: result.pricing
                }
                PropertyDeal.priceUpdate(form).$promise.then(() => $rootScope.$broadcast('property-deal.updated'))
            })
        }
        this.changeLivingAreaFinal = item => {
            let form = {
                id: this.id,
                itemId: item.id,
                livingArea: item.property.livingArea,
                livingAreaFinal: item.property.livingAreaFinal
            }
            return PropertyDealService.changeLivingAreaFinal(form)
        }
        this.changeBankAccount = (item) => {
            let form = {
                id: this.id,
                itemId: item.id,
                bankAccount: item.bankAccount
            }
            return PropertyDealService.changeBankAccount(form)
        }
        $scope.$on('property-deal.updated', () => $state.reload())
    })
